module.exports = __webpack_public_path__ + "static/media/sketching2.97629bdf.jpg";